import React, { useState } from "react";

import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";

import MenuIcon from "@mui/icons-material/Menu";
import { Box, IconButton, Typography } from "@mui/material";

import MobileMenu from "./MobileMenu";
import { StyledToolBar, StyledAppBar } from "../components/styles";

import Logo from "../images/logo.svg";

const getData = graphql`
  query MenuLinks {
    allSite {
      nodes {
        siteMetadata {
          siteMenu {
            link
            name
          }
        }
      }
    }
  }
`;

const Header = ({ location }) => {
  console.log("location", location);
  const data = useStaticQuery(getData);
  const { siteMenu } = data.allSite.nodes[0].siteMetadata;
  const [mobileMenu, setMobileMenu] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  return (
    <>
      <MobileMenu mobileMenu={mobileMenu} toggleMobileMenu={toggleMobileMenu} />
      <StyledAppBar component="nav" color="secondary">
        <StyledToolBar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            sx={{ mr: 2, display: { sm: "none" } }}
            onClick={toggleMobileMenu}
          >
            <MenuIcon />
          </IconButton>
          <img src={Logo} alt="Futuristic Studio logo" />
          <Box sx={{ display: { xs: "none", sm: "block" } }}>
            {siteMenu.map((item) => (
              <Box className="mui-btn" key={item.name}>
                <Link
                  to={`${item.link}`}
                  activeStyle={activeLinkStyle}
                  style={linkStyle}
                >
                  <Typography variant="body1">{item.name}</Typography>
                </Link>
              </Box>
            ))}
          </Box>
        </StyledToolBar>
      </StyledAppBar>
    </>
  );
};

export default Header;

const linkStyle = { textDecoration: "none", color: "#FFFEBF" };
const activeLinkStyle = { color: "#89FBFF" };
